import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { getTheme } from "../../Theme.js";
const theme = getTheme();

const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px;
`;

const Tittle = styled.h1`
  font-size: 4em;
  color: ${theme.MAIN_COLOR};
  text-align: center;
`;

const OptIn = () => {
  const history = useHistory();
  return (
    <Main>
      <Tittle>TCS SMS Opt-in</Tittle>

      <p>
        By opting into TCS SMS, you agree to receive text messages from TCS for
        verification purposes as well as important account updates. You may also
        utilize our clock in/out services as well as ask questions related to
        your account and information within TCS.
      </p>
      <h1>Verification</h1>
      <p>
        Users will receive a verification code via SMS to confirm their phone
        number. This ensures that the phone number provided is valid and can be
        used for important account notifications and provides a 2nd factor of
        authentication when logging into your account or changing account
        settings such as password and email.
      </p>
      <h1>Clock In/Out Services</h1>
      <p>
        Users can utilize TCS SMS to clock in and out of their shifts, providing
        a convenient and efficient way to track work hours.
      </p>
      <h1>Account Updates</h1>
      <p>
        Users will receive important account updates via SMS, ensuring they are
        always informed about changes to their account and any changes that may
        impact their use of TCS and personal data.
      </p>
      <h1>Support</h1>
      <p>
        Users can reach out to TCS support via SMS for any questions or issues
        related to their account or services. Such as requesting a link to view
        their timecard.
      </p>
    </Main>
  );
};
export default OptIn;
